// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1vdtE","heroContent":"hero-module--hero-content--2mSQC","heroTitle":"hero-module--hero-title--3vuHK","floor":"hero-module--floor--23Epm"};